<template lang="pug">
  .view-control-reports-detailed-lesson
    statistic(:url="statisticUrl")
</template>

<script>
export default {
  name: 'view-control-reports-detailed-lesson',

  computed: {
    statisticUrl() {
      let url = `/statistics/lessons-progress/${this.$route.params.lessonId}`;

      if (this.$route.params.userId) {
        url += `/users/${this.$route.params.userId}`;
      }

      return url;
    },
  },
};
</script>
